import React from "react";
import { Link } from "react-router-dom";
import MainFooter from "../shared/MainFooter.jsx";

const LegalPageShell = ({ title, children }) => (
  <div className="choice-landing min-h-screen bg-[#080b14] noise-overlay">
    <header className="border-b border-white/[0.05]">
      <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src="/images/logo.png" alt="FractoLabs" className="w-full max-w-[100px]" />
        </Link>
        <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors">
          ← Back to home
        </Link>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl md:text-4xl font-semibold text-white mb-8">{title}</h1>
      <div className="prose prose-invert prose-sm max-w-none text-gray-400 space-y-6">{children}</div>
    </main>

    <MainFooter />
  </div>
);

const PrivacyPolicyPage = () => (
  <LegalPageShell title="Privacy Policy">
    <p className="text-gray-500 text-sm">Last updated: June 2025</p>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Information we collect</h2>
      <p>
        When you use FractoLabs websites or submit forms (including the Custom Agent inquiry), we may collect your
        name, email address, business details, and usage information necessary to respond to your request or provide
        our services.
      </p>
    </section>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">How we use information</h2>
      <p>
        We use collected information to respond to inquiries, deliver and improve our AI employee services, communicate
        with you about your account or deployment, and comply with legal obligations.
      </p>
    </section>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Cookies</h2>
      <p>
        Our marketing sites may use essential cookies and analytics to understand traffic and improve the experience.
        You can control cookies through your browser settings.
      </p>
    </section>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Data sharing</h2>
      <p>
        We do not sell your personal information. We may share data with service providers who assist in operating our
        platform, subject to confidentiality obligations, or when required by law.
      </p>
    </section>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Contact</h2>
      <p>
        For privacy-related questions, contact{" "}
        <a href="mailto:support@fractolabs.com" className="text-teal-400 hover:text-teal-300">
          support@fractolabs.com
        </a>
        .
      </p>
    </section>
  </LegalPageShell>
);

export default PrivacyPolicyPage;
